<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-title-hang>
        <span slot="config_title_hang_ele2">{{ extensionTitle }}</span>
      </config-title-hang>

      <config-hang @click.native="addThirdPanelBtnHandle">
        <span slot="config_hang_ele2" class="device_go_online_btn_corol">添加新面板</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-title-hang>
        <span slot="config_title_hang_ele2">在线设备({{ computedonLineListNumber }}台)</span>
        <img slot="config_title_hang_ele5_img" src="~assets/img/config/shuaxin_bai.png" @click="updataBtnHandle" alt />
        <span slot="config_title_hang_ele5" @click="updataBtnHandle">刷新</span>
      </config-title-hang>

      <config-hang :buttonHangEle6Warn="true" @click.native="thirdPanelBtnHandle(value, index, 'onLine')"
        v-for="(value, index) in thirdPanelListData.onLineList" :key="value.productId">
        <span slot="config_button_hang_ele6" @click.stop="downloadThirdPanelAddressBtnHandle(value)">设置地址</span>
        <span slot="config_button_hang_ele5" @click.stop="thirdPanelLocationBtnHandle(value)">设备定位</span>

        <span slot="config_hang_ele2_1" :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
          {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.productName :
            value.productName
          }}
        </span>
        <span slot="config_hang_ele2_2"> 地址:{{ value.address }} 代码:{{ value.program }}</span>
        <span slot="config_hang_ele3">{{ value.remark }}</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <config-title-hang v-show="thirdPanelListData.offLineList.length != 0">
        <span slot="config_title_hang_ele2">离线设备({{ computedoffLineListNumber }}台)</span>
      </config-title-hang>

      <config-hang :buttonHangEle6Warn="true" @click.native="thirdPanelBtnHandle(value, index, 'offLine')"
        v-for="(value, index) in thirdPanelListData.offLineList" :key="value.productId">
        <span slot="config_button_hang_ele6" @click.stop="downloadThirdPanelAddressBtnHandle(value)">设置地址</span>
        <span slot="config_button_hang_ele5" @click.stop="thirdPanelLocationBtnHandle(value)">设备定位</span>

        <span slot="config_hang_ele2_1" :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
          {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.productName :
            value.productName
          }}
        </span>
        <span slot="config_hang_ele2_2" class="device_go_online_btn_corol"> 地址:{{ value.address }} 代码:{{
          value.program }}</span>
        <span slot="config_hang_ele3">{{ value.remark }}</span>
        <div slot="config_hang_da_view_img"
          @click.stop="deleteThirdPanelBtnHandle(thirdPanelListData.offLineList, index)">
          <img src="~assets/img/config/delete_lan.png" alt />
        </div>
      </config-hang>

      <div class="xiaotishi_style">总键位:{{ thirdPanelListData.capacityTotal }} 已用:{{
        thirdPanelListData.capacityUsed }} 剩余:{{ thirdPanelListData.capacityRemain }}</div>
      <div v-if="thirdPanelListData.errorMsg && thirdPanelListData.errorMsg !== ''" class="xiaotishi_style">
        警告: {{ thirdPanelListData.errorMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";

export default {
  data() {
    return {
      query: {},
      thirdPanelListData: {
        extensionProductId: "",
        offLineList: [],
        onLineList: [],
        capacityTotal: 0,
        capacityUsed: 0,
        capacityRemain: 0,
        errorMsg: ""
      }
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  computed: {
    extensionTitle() {
      return (this.query.productName || "面板扩展模块") + "(" + (this.query.borderInnerAddress || this.query.address || "") + "|" + (this.query.program || "") + ")";
    },
    computedoffLineListNumber() {
      return this.thirdPanelListData.offLineList.length;
    },
    computedonLineListNumber() {
      return this.thirdPanelListData.onLineList.length;
    },
    queryState() {
      return this.query.type === "onLine" ? 1 : 0;
    }
  },
  methods: {
    initThirdPanelList() {
      let storeData = this.$store.state.configinfo.panelExtensionThirdPanelListData;
      // 扩展面板列表由入口页或添加页提前写入Vuex, 返回本页面时优先读缓存, 避免重复调用阻塞接口.
      if (storeData.extensionProductId === this.query.productId) {
        this.thirdPanelListData = storeData;
        return;
      }
      this.getThirdPanelList(this.queryState);
    },
    getThirdPanelList(state) {
      this.$request({
        method: "post",
        url: "/panelExtension/findThirdPanelListByExtensionId",
        // 后端此接口最大超时经过计算为60*100+3000 = 9000ms 详见后端代码 serverWaitTime
        timeout: 11000,
        data: {
          token: this.$store.state.token,
          extensionProductId: this.query.productId,
          state: state
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            let data = res.data.data;
            this.thirdPanelListData = this.formatPanelExtensionThirdPanelListData(data);
            // 手动刷新或直达本页面时, 接口结果同步到Vuex, 供添加页返回后继续沿用.
            this.$store.dispatch(
              "asyUpdataPanelExtensionThirdPanelListData",
              this.thirdPanelListData
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatPanelExtensionThirdPanelListData(data) {
      return {
        extensionProductId: this.query.productId,
        offLineList: data.offLineList || [],
        onLineList: data.onLineList || [],
        capacityTotal: data.capacityTotal || 0,
        capacityUsed: data.capacityUsed || 0,
        capacityRemain: data.capacityRemain || 0,
        errorMsg: data.errorMsg || ""
      };
    },
    updataBtnHandle() {
      this.getThirdPanelList(this.queryState);
    },
    addThirdPanelBtnHandle() {
      this.$router.push({
        path: "addThirdPanel",
        query: this.query
      });
    },
    thirdPanelBtnHandle(value, index, type) {
      this.$router.push({
        path: "thirdPanelDeviceManage",
        query: {
          extensionProductId: this.query.productId,
          extensionProductName: this.query.productName,
          extensionAddress: this.query.address,
          extensionBorderInnerAddress: this.query.borderInnerAddress,
          extensionProgram: this.query.program,
          address: value.address,
          remark: value.remark,
          productName: value.productName,
          productId: value.productId,
          Cindex: index,
          productCode: value.productCode,
          program: value.program,
          productSource: value.productSource,
          type: type
        }
      });
    },
    downloadThirdPanelAddressBtnHandle(value) {
      this.$request({
        method: "post",
        url: "/panelExtension/downloadThirdPanelAddress",
        data: {
          token: this.$store.state.token,
          extensionProductId: this.query.productId,
          thirdPanelProductId: value.productId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            this.$showTipsToast(1, "成功,请检查或继续操作~", true, 3000);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    thirdPanelLocationBtnHandle(value) {
      this.$request({
        method: "post",
        url: "/panelExtension/thirdPanelLocation",
        data: {
          token: this.$store.state.token,
          extensionProductId: this.query.productId,
          thirdPanelProductId: value.productId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            this.$showTipsToast(1, "定位成功~", true, 3000);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteThirdPanelBtnHandle(value, index) {
      this.$showTipsToast(25, {
        deleteList: value,
        thirdPanelListData: this.thirdPanelListData
      }, false, 1000, index);
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.initThirdPanelList();
  },
  activated() {
    this.initThirdPanelList();
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
